<div class="page">

  <div class="pagehead">
    <div>
      <h1>PAN card services</h1>
      <p>Apply for a new PAN or start a correction — you'll be redirected to the NSDL flow</p>
    </div>
    <div class="filters">
      <div class="seg" role="tablist" aria-label="Service">
        <button type="button" [class.on]="isGenerate" (click)="complaintType('generateurl')">Apply new PAN</button>
        <button type="button" [class.on]="isCorrection" (click)="complaintType('correction')">PAN correction</button>
      </div>
    </div>
  </div>

  <!-- ============ NEW PAN ============ -->
  <div class="card form-card" *ngIf="isGenerate">
    <div class="clabel"><svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M7 9h5M7 13h3"/></svg>Applicant details</div>
    <form [formGroup]="GenerateUrlForm" class="kit-form">
      <div class="form-grid">
        <div class="er-field"
          [class.has-error]="GenerateUrlForm.get('mode').invalid && GenerateUrlForm.get('mode').touched">
          <label class="er-field__label" for="pan-mode">Mode <span class="req">*</span></label>
          <select id="pan-mode" class="er-select" formControlName="mode" (change)="onSelectMode({ value: $any($event.target).value })" required>
            <option value="" disabled selected hidden>How will the application go in?</option>
            <option *ngFor="let mode of modes" [value]="mode.value">{{ mode.modeName }}</option>
          </select>
          <div class="er-field__error" *ngIf="GenerateUrlForm.hasError('required','mode') && GenerateUrlForm.get('mode').touched">Select a mode</div>
        </div>

        <div class="er-field"
          [class.has-error]="GenerateUrlForm.get('title').invalid && GenerateUrlForm.get('title').touched">
          <label class="er-field__label" for="pan-title">Title <span class="req">*</span></label>
          <select id="pan-title" class="er-select" formControlName="title" required>
            <option value="" disabled selected hidden>Select title</option>
            <option *ngIf="isMale || isOther" value="1">Shri</option>
            <option *ngIf="isFemale || isOther" value="2">Smt.</option>
            <option *ngIf="isFemale || isOther" value="3">Kumari</option>
          </select>
          <div class="er-field__error" *ngIf="GenerateUrlForm.hasError('required','title') && GenerateUrlForm.get('title').touched">Select a title</div>
        </div>

        <div class="er-field"
          [class.has-error]="GenerateUrlForm.get('firstname').invalid && GenerateUrlForm.get('firstname').touched">
          <label class="er-field__label" for="pan-first">First name <span class="req">*</span></label>
          <div class="er-field__wrap">
            <input id="pan-first" class="er-field__control" formControlName="firstname" pattern="^[a-zA-Z]*$"
              placeholder="As per Aadhaar" required>
          </div>
          <div class="er-field__error" *ngIf="GenerateUrlForm.hasError('required','firstname') && GenerateUrlForm.get('firstname').touched">Enter the first name</div>
          <div class="er-field__error" *ngIf="GenerateUrlForm.controls.firstname.errors?.pattern">Enter a valid first name</div>
        </div>

        <div class="er-field">
          <label class="er-field__label" for="pan-middle">Middle name</label>
          <div class="er-field__wrap">
            <input id="pan-middle" class="er-field__control" formControlName="middlename" placeholder="Optional">
          </div>
        </div>

        <div class="er-field"
          [class.has-error]="GenerateUrlForm.get('lastname').invalid && GenerateUrlForm.get('lastname').touched">
          <label class="er-field__label" for="pan-last">Last name <span class="req">*</span></label>
          <div class="er-field__wrap">
            <input id="pan-last" class="er-field__control" formControlName="lastname" pattern="^[a-zA-Z ]*$"
              placeholder="As per Aadhaar" required>
          </div>
          <div class="er-field__error" *ngIf="GenerateUrlForm.hasError('required','lastname') && GenerateUrlForm.get('lastname').touched">Enter the last name</div>
          <div class="er-field__error" *ngIf="GenerateUrlForm.controls.lastname.errors?.pattern">Enter a valid last name</div>
        </div>

        <div class="er-field" *ngIf="isEmailField"
          [class.has-error]="GenerateUrlForm.get('email').invalid && GenerateUrlForm.get('email').touched">
          <label class="er-field__label" for="pan-email">Email <span class="req">*</span></label>
          <div class="er-field__wrap">
            <input id="pan-email" class="er-field__control" formControlName="email" placeholder="applicant@email.com" required>
          </div>
          <div class="er-field__error" *ngIf="GenerateUrlForm.hasError('required','email') && GenerateUrlForm.get('email').touched">Enter the email</div>
        </div>

        <div class="er-field span-2">
          <label class="er-field__label">Gender <span class="req">*</span></label>
          <mat-radio-group formControlName="gender" (change)="onSelectGender($event.value)">
            <mat-radio-button class="gender-radio" value="MALE">Male</mat-radio-button>
            <mat-radio-button class="gender-radio" value="FEMALE">Female</mat-radio-button>
            <mat-radio-button class="gender-radio" value="OTHER">Other</mat-radio-button>
          </mat-radio-group>
          <div class="er-field__error" *ngIf="GenerateUrlForm.hasError('required','gender') && GenerateUrlForm.get('gender').touched">Select a gender</div>
        </div>
      </div>

      <div class="form-actions">
        <button type="button" class="er-btn er-btn--primary" (click)="formSubmit('generate')">Submit application</button>
      </div>
    </form>
  </div>

  <!-- ============ CORRECTION ============ -->
  <div class="card form-card" *ngIf="isCorrection">
    <div class="clabel"><svg viewBox="0 0 24 24"><path d="M4 20l4-1 11-11-3-3L5 16l-1 4z"/></svg>Correction details</div>
    <form [formGroup]="CorrectionForm" class="kit-form">
      <div class="form-grid">
        <div class="er-field"
          [class.has-error]="CorrectionForm.get('mode').invalid && CorrectionForm.get('mode').touched">
          <label class="er-field__label" for="cor-mode">Mode <span class="req">*</span></label>
          <select id="cor-mode" class="er-select" formControlName="mode" (change)="onSelectMode({ value: $any($event.target).value })" required>
            <option value="" disabled selected hidden>How will the correction go in?</option>
            <option *ngFor="let mode of modes" [value]="mode.value">{{ mode.modeName }}</option>
          </select>
          <div class="er-field__error" *ngIf="CorrectionForm.hasError('required','mode') && CorrectionForm.get('mode').touched">Select a mode</div>
        </div>

        <div class="er-field"
          [class.has-error]="CorrectionForm.get('title').invalid && CorrectionForm.get('title').touched">
          <label class="er-field__label" for="cor-title">Title <span class="req">*</span></label>
          <select id="cor-title" class="er-select" formControlName="title" required>
            <option value="" disabled selected hidden>Select title</option>
            <option *ngIf="isMale || isOther" value="1">Shri</option>
            <option *ngIf="isFemale || isOther" value="2">Smt.</option>
            <option *ngIf="isFemale || isOther" value="3">Kumari</option>
          </select>
          <div class="er-field__error" *ngIf="CorrectionForm.hasError('required','title') && CorrectionForm.get('title').touched">Select a title</div>
        </div>

        <div class="er-field"
          [class.has-error]="CorrectionForm.get('firstname').invalid && CorrectionForm.get('firstname').touched">
          <label class="er-field__label" for="cor-first">First name <span class="req">*</span></label>
          <div class="er-field__wrap">
            <input id="cor-first" class="er-field__control" formControlName="firstname" placeholder="As per PAN" required>
          </div>
          <div class="er-field__error" *ngIf="CorrectionForm.hasError('required','firstname') && CorrectionForm.get('firstname').touched">Enter the first name</div>
          <div class="er-field__error" *ngIf="CorrectionForm.controls.firstname.errors?.pattern">Enter a valid first name</div>
        </div>

        <div class="er-field">
          <label class="er-field__label" for="cor-middle">Middle name</label>
          <div class="er-field__wrap">
            <input id="cor-middle" class="er-field__control" formControlName="middlename" placeholder="Optional">
          </div>
        </div>

        <div class="er-field"
          [class.has-error]="CorrectionForm.get('lastname').invalid && CorrectionForm.get('lastname').touched">
          <label class="er-field__label" for="cor-last">Last name <span class="req">*</span></label>
          <div class="er-field__wrap">
            <input id="cor-last" class="er-field__control" formControlName="lastname" placeholder="As per PAN" required>
          </div>
          <div class="er-field__error" *ngIf="CorrectionForm.hasError('required','lastname') && CorrectionForm.get('lastname').touched">Enter the last name</div>
          <div class="er-field__error" *ngIf="CorrectionForm.controls.lastname.errors?.pattern">Enter a valid last name</div>
        </div>

        <div class="er-field" *ngIf="isEmailField"
          [class.has-error]="CorrectionForm.get('email').invalid && CorrectionForm.get('email').touched">
          <label class="er-field__label" for="cor-email">Email <span class="req">*</span></label>
          <div class="er-field__wrap">
            <input id="cor-email" class="er-field__control" formControlName="email" placeholder="applicant@email.com" required>
          </div>
          <div class="er-field__error" *ngIf="CorrectionForm.hasError('required','email') && CorrectionForm.get('email').touched">Enter the email</div>
        </div>

        <div class="er-field span-2">
          <label class="er-field__label">Gender <span class="req">*</span></label>
          <mat-radio-group formControlName="gender" (change)="onSelectGender($event.value)">
            <mat-radio-button class="gender-radio" value="MALE">Male</mat-radio-button>
            <mat-radio-button class="gender-radio" value="FEMALE">Female</mat-radio-button>
            <mat-radio-button class="gender-radio" value="OTHER">Other</mat-radio-button>
          </mat-radio-group>
          <div class="er-field__error" *ngIf="CorrectionForm.hasError('required','gender') && CorrectionForm.get('gender').touched">Select a gender</div>
        </div>
      </div>

      <div class="form-actions">
        <button type="button" class="er-btn er-btn--primary" (click)="formSubmit('correction')">Submit correction</button>
      </div>
    </form>
  </div>

</div>

